<template>
<div>
	<v-dialog
		v-model="dialog"
		persistent
		width="1000"
	>
		<v-card>
			<v-card-title
					class="headline light-blue darken-1 white--text"
					primary-title
			>
				{{$t('workers.accommodation')}}
			</v-card-title>
			<v-card-text>
				<v-container grid-list-lg>
					<v-layout row>
						<v-flex sm6 md4>
							<v-text-field :label="$t('workers.room_number')"
								v-model="formData.room_number"
							/>
						</v-flex>
						<v-flex sm6 md4>
							<Datepicker
								:label="$t('workers.date_start')"
								:error-messages="validate.date"
								v-model="formData.started_at"
							/>
						</v-flex>
						<v-flex sm6 md4>
							<Datepicker
								:label="$t('workers.date_end')"
								:error-messages="validate.date"
								v-model="formData.ended_at"
							/>
						</v-flex>
					</v-layout>
					<v-layout>
						<v-flex>
							<v-switch v-model="isSingleAddress" label="Single address" />
						</v-flex>
					</v-layout>
					<v-layout v-if="isSingleAddress">
						<AddressGroup
							:main-label="$t('address.agency_address')"
							:main-address="currentAddress"
							:onlyMain="true"
							@createOne="createAddressOne"
							@update="updateAddressWithNotify"
							@delete="deleteAddressWithNotify"
							:hideDelete="true"
						/>
					</v-layout>
					<v-layout v-else>
						<address-by-human
							:list-human="landlords"
							:list-address="address"
							:humanId="formData.landlord_id"
							:labelHuman="$t('workers.landlord')"
							:addressId="formData.apartment_address_id"
							@update:humanId="updateLandlord"
							@update:addressId="updateLandlordAddress"
							@getAddress="getAddress"
							:errorHuman="validate.landlord"
						/>
					</v-layout>
				</v-container>
			</v-card-text>

			<v-divider />

			<v-card-actions>
				<v-spacer />
				<v-btn
					color="red light-1"
					flat
					@click="cancel"
				>
					{{$t('common.cancel')}}
				</v-btn>
				<v-btn
					color="green light-1"
					flat
					@click="saveWithValidation"
				>
					{{$t('common.save')}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	<v-tooltip top slot="activator">
		<v-btn
			slot="activator"
			@click="open"
			color="red"
			dark
			fab
		>
			<v-icon>add</v-icon>
		</v-btn>
		{{$t('workers.add_accommodation')}}
	</v-tooltip>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Datepicker from '../../../../components/DatePicker'
import AddressByHuman from '../../../../components/address-by-human/AddressByHuman'
import AddressGroup from '../../../../components/address-group/AddressGroup'
import { validateDataStartEnd } from '../../../../utils/helpers'
import { notify } from '../../../../utils/notifications'

export default {
	data() {
		return {
			model: false,
			isSingleAddress: false,
			currentAddress: null
		}
	},
	components: {
		Datepicker,
		AddressByHuman,
		AddressGroup
	},
	props: {
		dialog: Boolean,
		landlords: Array,
		formData: {
			landlord_id: [String, Number],
			apartment_address_id: [String, Number],
			started_at: String,
			ended_at: String,
			room_number: String,
			apartment_address_data: Object
		}
	},
	watch: {
		dialog() {
			if(this.formData.landlord_id == null) {
				this.isSingleAddress = true
				this.currentAddress = this.formData.apartment_address
			} else {
				this.isSingleAddress = false
				this.currentAddress = null
			}
		}
	},
	computed: {
		...mapState({
			address: ({ landlords }) =>
				landlords.detail.landlord_apartment_address || []
		}),
		validate() {
			const { ended_at, started_at } = this.formData
			const date = validateDataStartEnd(started_at, ended_at)
				? this.$t('workers.start_end_valid')
				: null

			return {
				date
			}
		}
	},
	methods: {
		...mapActions({
			getAddress: 'landlords/getLandlord',
			createAddress: 'landlords/createAddress',
			updateAddress: 'landlords/updateAddress',
			deleteAddress: 'landlords/deleteAddress'
		}),
		saveWithValidation() {
			const error= Object.values(this.validate).find(error => error)
			if (error) return false

			let query = this.formData
			query.apartment_address_data = this.currentAddress
			this.$emit('save', query)
		},

		cancel() {
			this.$emit('cancel')
		},
		open() {
			this.$emit('open')
			this.dialog = true
		},
		updateLandlord(value) {
			this.$parent.propForm.formData.landlord_id = value
		},
		updateLandlordAddress(value) {
			this.$parent.propForm.formData.apartment_address_id = value
		},
		createAddressOne(data) {
			this.currentAddress = data
		},
		updateAddressWithNotify(data) {
			this.currentAddress = data
		},
		deleteAddressWithNotify(id) {
			this.deleteAddress(id).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.deleted', {
						type: this.$t('address.address')
					})
				})
			})
		}
	}
}
</script>
